export const home_zh = {
    home: {
        assets:"资产",
        interval:"间隔",
        introduce:"介绍",
        tradingVolume:"最新大额交易",
        tradingHours:"交易时间",
        checkDetails:"查看详情",
        details:"详情",
        date:"日期",
        number:"交易额",
        address:"地址",
        toAddress:"转入地址",
        height:"区块高度",
        outAddress:"转出地址",
        transaction:"交易ID",
        shutDown:"关闭",
        startDate:"开始日期",
        endDate:"结束日期",
        no:"无",
        Range:"范围选择查询",
        search:"搜索 Address/amount/txid",
        relationship:"地址对应标记持有者名称关系列表",
        markName:"标记持有者姓名",
        trading:"交易对",
        currency:"币价",
        dayCurrency:"24小时币价",
        currencyName:"币名简称",
        contractAddress:"合约地址",
        aAddress:"发起地址",
        targetAddress:"目标地址",
        down:"关闭",
        bigTable:"大额交易列表",
        activeAddress:"合约地址",
        searchs:"搜索 地址/余额/交易hash",
        ethereum:"以太坊巨鲸地址余额列表",
        balance:"您的账户余额信息",
        searchAddress:"搜索 Address / value",
        serialNumber:"序号",
        aCurrency:"币数量",
        notPage:"暂无此页面",
        ascending:"升 序",
        descending:"降 序",
        voutn:"该笔交易索引号",
        vouttype:"接收地址类型",
        days:"持有天数",
        buyPrice:"买入价格",
        sellPrice:"卖出价格",
        profit:"利润",
        vout:"接收地址",
        fromAbbr:"转入合约",
        toAbbr:"转出合约",
        fromTag:"转入地址标识",
        toTag:"转出地址标识",
        tag:"地址标识",
        favorite:"喜欢",
        compare:"",
        switch:"线性/对数：",
        switch1:"线性",
        switch2:"对数",
        hash:"交易hash",
        compare:"比较",
        create:"创建警报",
        abbr:"请选择",
        smaWarning:"请输入0-100之间的整数!",
        PersonalInformation:"个人信息",
        sex:"性别",
        loginIp:"最近登录IP",
        loginCount:"登录次数",
        figure:"图1",
        figure2:"图2",
        figure3:"图3",
        figure4:"图4",
        table:"表1",
        table2:"表2",
        searchResults:"USDC大额交易监控表格",
        loginDate:"登录时间",
        open:"开盘",
        highestPrice:"最高",
        ndaqAmount:"成交量",
        closePrice:"收盘",
        lowestPrice:"最低",
        clinch:"成交额",
        amplitude:"振幅",
        rise:"涨跌额",
        picture:"涨跌幅",
        copy:"复制成功",
        copyTabel:"双击复制表格内容",
        action:"行为",
        NoData:"无数据",
        formula:"计算公式",
        topList:"巨鲸地址列表",
        sopr:"已花费输出盈利比",
        lthSopr:"长期持有者的已花费输出盈利比",
        sthSopr:"短期持有者的已花费输出盈利比",
        Increase:"当日涨幅",
        tag1:"标签",
        loadingData:"数据努力加载中...",
        Destruction:"销毁",
        casting:"铸造",
        minutes5:"5分钟",
        minutes15:"15分钟",
        minutes30:"30分钟",
        hour1:"1小时",
        hour2:"2小时",
        hour4:"4小时",
        hour6:"6小时",
        hour12:"12小时",
        day1:"1天",
        month1:"1月",
        month3:"3月",
        month6:"6月",
        year1:"1年",
        year2:"2年",
        year5:"5年",
        year10:"10年",
        year20:"20年",
        year30:"30年",
        introduction:"指标介绍",
        welcome:"欢迎使用coinbus指标文档介绍",
        totalAmount:"总金额",
        Adjusted:"经过季节性调整",
        Unadjusted:"未经过季节性调整",
        cash:"现金（流通中的纸币和硬币）",
        deposit:"存款准备金",
        cash2:"现金",
        current:"活期存款",
        check:"旅行支票账户",
        depositCheck:"其他存款人存款支票账户",
        savings:"储蓄存款",
        regular:"定期存款",
        otherDeposits:"其他存款人存款",
        private:"私营部门贷款",
        GDP:"全年GDP",
        unit:"单位",
        M1:"M1说明：2020年5月之前，M1由",
        M1_1:"(1)美国财政部、联邦储备银行和存款机构金库以外的货币组成；",
        M1_2:"(2)商业银行的活期存款（不包括存款机构、美国政府、外国银行和官方机构持有的金额）减去托收过程中的现金项目和美联储浮动资金；",
        M1_3:"(3) 其他支票存款 (OCD)，包括可转让提款指令 (NOW) 和自动转账服务 (ATS)、存款机构账户、信用社共享汇票账户以及储蓄机构活期存款。",
        M1_4:"从 2020 年 5 月开始，M1 包括",
        M1_5:"(1) 美国财政部、联邦储备银行以外的货币，以及存款机构的金库；",
        M1_6:"(2)商业银行的活期存款（不包括存款机构、美国政府、外国银行和官方机构持有的金额）减去托收过程中的现金项目和美联储浮动资金；",
        M1_7:"(3) 其他流动性存款，包括强迫存款和储蓄存款（包括货币市场存款账户）。季节性调整后的 M1 是通过对货币、活期存款和 OCD（2020 年 5 月之前）或其他流动存款（2020 年 5 月开始）求和得出的，每一项都单独进行季节性调整。",
        M2:"M2说明：2020年5月之前，M2由M1加",
        M2_1:"(1)储蓄存款（含货币市场存款账户）组成；",
        M2_2:"(2)小面额定期存款（金额低于10万美元的定期存款）减去个人退休账户（IRA）和存款机构的基奥余额；",
        M2_3:"(3) 零售货币市场基金 (MMF) 余额减去 MMF 中的 IRA 和 Keogh 余额。",
        M2_4:"从 2020 年 5 月开始，M2 由 M1 加上",
        M2_5:"(1) 小面额定期存款（金额低于 10 万美元的定期存款）减去存款机构的 IRA 和 Keogh 余额组成；",
        M2_6:"(2) 零售 MMF 余额减去 IRA 和基奥 MMF 余额。季节性调整后的 M2 是通过将储蓄存款（2020 年 5 月之前）、小面额定期存款和零售货币市场基金（分别经过季节性调整）相加，并将此结果添加到季节性调整后的 M1 中得出的。",
        newContractSearch:"搜索地址/交易Hash",
        ranking:"排名",
        ethPrice:"价格曲线无数据",
        GDPRemind:"注：时间查询按年返回数据",
        loading:"加载 ",
        ago:" 前的数据...",
        after:" 后的数据...",
        updateContent:"更新内容",
        noPage:" 对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。",
        canTFind:"找不到网页！",
        realTimeData:"实时数据",
        VPN:"请打开VPN稳定访问该表格",

    },


};
export const home_en = {
    home: {
        assets:"assets",
        interval:"interval",
        introduce:"introduce",
        tradingVolume:"Maximum trading volume",
        tradingHours:"Trading hours",
        checkDetails:"Check the details",
        details:"details",
        date:"date",
        number:"Transaction volume",
        address:"address",
        toAddress:"To address",
        height:"Block height",
        outAddress:"Turns out the address",
        transaction:"Transaction ID",
        shutDown:"Shut down",
        startDate:"Start date",
        endDate:"End date",
        no:"There is no",
        Range:"selection query",
        search:"search Address/amount/txid",
        relationship:"Addresses correspond to a relational list of tag holder names",
        markName:"Name of Mark Holder",
        trading:"Trading on",
        currency:"currency",
        dayCurrency:"24-hour coin price",
        currencyName:"Currency name for short",
        contractAddress:"Contract address",
        aAddress:"A address",
        targetAddress:"The target address",
        down:"Shut down",
        bigTable:"Large Transaction Form",
        activeAddress:"Address of contract",
        searchs:"address/balance/Transaction hash",
        ethereum:"Ethereum Whale address balance list",
        balance:"Your account balance information",
        searchAddress:"search Address / value",
        serialNumber:"number",
        aCurrency:"A currency",
        notPage:"This page is not available",
        ascending:"ascending",
        descending:"Descending order",
        voutn:"vout.n",
        vouttype:"receive address type",
        days:"holder days",
        buyPrice:"buyin price",
        sellPrice:"sellout price",
        profit:"profit",
        vout:"receive address",
        fromAbbr:"Transfer to contract",
        toAbbr:"Transfer contract",
        fromTag:"Transfer address identification",
        toTag:"Transfer out address identification",
        tag:"Address label",
        favorite:"Favorite",
        switch:"Linear/logarithmic display:",
        switch1:"Linear",
        switch2:"Log",
        hash:"transaction hash id",
        compare:"Compare",
        create:"Create Alert",
        abbr:"Please select",
        smaWarning:"The value cannot be greater than 100. Re-enter!",
        PersonalInformation:"Personal information",
        sex:"gender",
        loginIp:"Last Login IP Address",
        loginCount:"Number of logins",
        figure:"Figure1",
        figure2:"Figure2",
        figure3:"Figure3",
        figure4:"Figure4",
        table:"table 1",
        table2:"table 2",
        searchResults:"USDC Bulk Transaction Monitoring form",
        loginDate:"Login time",
        open:"Opening",
        highestPrice:"highest",
        ndaqAmount:"Volume of trading",
        closePrice:"closing",
        lowestPrice:"lowest",
        clinch:"Transaction forehead",
        amplitude:"amplitude",
        rise:"Up down amount",
        picture:"Rise and fall",
        copy:"Replication succeeded",
        copyTabel:"Double-click to copy the table contents",
        action:"behavior",
        NoData:"No data",
        formula:"Calculation formula",
        topList:"Giant Whale Address List",
        sopr:"Expended output profit ratio",
        lthSopr:"Long-term holders' spent output profit ratio",
        sthSopr:"Short term holders' spent output profit ratio",
        Increase:"Intraday increase",
        tag1:"tag",
        loadingData:"Effort loading data...",
        Destruction:"Destruction",
        casting:"casting",
        minutes5:"5 minutes",
        minutes15:"15 minutes",
        minutes30:"30 minutes",
        hour1:"1 hour",
        hour2:"2 hour",
        hour4:"4 hour",
        hour6:"6 hour",
        hour12:"12 hour",
        day1:"1 day",
        introduction:"Introduction",
        month1:"1 month",
        month3:"3 months",
        month6:"6 months",
        year1:"1 year",
        year2:"2 years",
        year5:"5 years",
        year10:"10 years",
        year20:"20 years",
        year30:"30 years",
        welcome:"Welcome to the Coinbus metric document introduction",
        totalAmount:"Total amount",
        Adjusted:"Seasonally adjusted",
        Unadjusted:"Not seasonally adjusted",
        cash:"Cash (notes and coins in circulation)",
        deposit:"Deposit reserve",
        cash2:"cash",
        current:"Demand deposit",
        check:"Traveller's cheque account",
        depositCheck:"Other depositors' deposit check accounts",
        savings:"Savings account",
        regular:"Fixed deposit",
        otherDeposits:"Deposits from other depositors",
        private:"loans to private sector",
        GDP:"GDP",
        unit:"unit",
        M1:"M1 description:Before May 2020, M1 consists of ",
        M1_1:"(1) currency outside the U.S. Treasury, Federal Reserve Banks, and the vaults of depository institutions;",
        M1_2:"(2) demand deposits at commercial banks (excluding those amounts held by depository institutions, the U.S. government, and foreign banks and official institutions) less cash items in the process of collection and Federal Reserve float; and",
        M1_3:"(3) other checkable deposits (OCDs), consisting of negotiable order of withdrawal, or NOW, and automatic transfer service, or ATS, accounts at depository institutions, share draft accounts at credit unions, and demand deposits at thrift institutions. ",
        M1_4:" Beginning May 2020, M1 consists of ",
        M1_5:"(1) currency outside the U.S. Treasury, Federal Reserve Banks, and the vaults of depository institutions;",
        M1_6:"(2) demand deposits at commercial banks (excluding those amounts held by depository institutions, the U.S. government, and foreign banks and official institutions) less cash items in the process of collection and Federal Reserve float; and ",
        M1_7:"(3) other liquid deposits, consisting of OCDs and savings deposits (including money market deposit accounts). Seasonally adjusted M1 is constructed by summing currency, demand deposits, and OCDs (before May 2020) or other liquid deposits (beginning May 2020), each seasonally adjusted separately.",
        M2:"M2 description:Before May 2020, M2 consists of M1 plus",
        M2_1:"(1) savings deposits (including money market deposit accounts);",
        M2_2:"(2) small-denomination time deposits (time deposits in amounts of less than $100,000) less individual retirement account (IRA) and Keogh balances at depository institutions; and",
        M2_3:"(3) balances in retail money market funds (MMFs) less IRA and Keogh balances at MMFs.",
        M2_4:"Beginning May 2020, M2 consists of M1 plus",
        M2_5:"(1) small-denomination time deposits (time deposits in amounts of less than $100,000) less IRA and Keogh balances at depository institutions; and ",
        M2_6:"(2) balances in retail MMFs less IRA and Keogh balances at MMFs. Seasonally adjusted M2 is constructed by summing savings deposits (before May 2020), small-denomination time deposits, and retail MMFs, each seasonally adjusted separately, and adding this result to seasonally adjusted M1.",
        newContractSearch:"Search Address/Transaction Hash",
        ranking:"#",
        ethPrice:"No data on price curve",
        GDPRemind:"Note: Time query returns data by year",
        loading:"loading ",
        ago:" Previous data...",
        after:" Subsequent data...",
        updateContent:"Update content",
        noPage:" Sorry, the page you are looking for does not exist. Try checking for errors in the URL, then press the refresh button on the browser or try to find other content in our application.",
        canTFind:"Unable to find webpage!",
        realTimeData:"realTimeData",
        VPN:"Please open VPN to stably access this table",

    },  
    


};